import VueType from 'vue';
import { SpatialFocusService, KeyMap } from './spatial_focus';
import type { CustomScrollBehaviorCallback } from 'scroll-into-view-if-needed/typings/types';

declare module 'vue/types/vue' {
  interface Vue {
    $spatialFocus: SpatialFocusService;
  }
}

export interface SpatialNavigationOptions {
  keyMap: KeyMap;
  scrollBehavior?: CustomScrollBehaviorCallback<void>;
}

enum Keycodes {
  ARROW_UP = 38,
  ARROW_DOWN = 40,
  ARROW_LEFT = 37,
  ARROW_RIGHT = 29,
  ENTER = 13,
  BACKSPACE = 8,
}

const defaultOptions = {
  keyMap: {
    up: Keycodes.ARROW_UP,
    down: Keycodes.ARROW_DOWN,
    left: Keycodes.ARROW_LEFT,
    right: Keycodes.ARROW_RIGHT,
    enter: Keycodes.ENTER,
    back: Keycodes.BACKSPACE,
  },
};

export default {
  install: (Vue: typeof VueType, options: SpatialNavigationOptions = defaultOptions) => {
    const focusService: SpatialFocusService = new SpatialFocusService(
      options.keyMap,
      options.scrollBehavior,
    );

    Vue.prototype.$spatialFocus = focusService;

    Vue.directive('spatial-element', {
      bind: (el, binding) => {
        focusService.addElement(el, binding.value);
      },

      unbind: (el, binding) => {
        focusService.removeElement(el, binding.value);
      },
    });

    Vue.directive('spatial-container', {
      bind: (el, binding) => {
        focusService.addContainer(el, binding.value);
      },

      unbind: (el) => {
        focusService.removeContainer(el);
      },
    });
  },
};
